import * as React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  PlayerContainer,
  PlayerVideo
} from './style'
import Player from '@vimeo/player'
import { useEffect, useRef, useState } from 'react'
import { VIDEO_COMPLETE, VIDEO_PROGRESS, VIDEO_START } from '@/utils/gtmEvents'
const DEFAULT_VIDEO_THRESHOLDS = [
  {
    time: 25,
    reached: false
  },
  {
    time: 50,
    reached: false
  },
  {
    time: 75,
    reached: false
  }
]
const ArticleBlockVideo = ({
  url = '',
  title = '',
  isLarge = false
}) => {
  const code = url.split('/')[3]
  const iframeRef = useRef(null)
  const [videoThresholds, setVideoThresholds] = useState(DEFAULT_VIDEO_THRESHOLDS)
  const [hasBeenStarted, setHasBeenStarted] = useState(false)

  const triggerGtmEventVideo = (videoTitle) => {
    setVideoThresholds(DEFAULT_VIDEO_THRESHOLDS)
    typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push({
      event: VIDEO_START,
      video_title: videoTitle
    })
  }
  useEffect(() => {
    const player = new Player(iframeRef.current)
    player.on('play', (e) => {
      if (!hasBeenStarted) {
        setHasBeenStarted(true)
        triggerGtmEventVideo(title)
      }
    })
    player.on('timeupdate', (e) => {
      const percent = (e.percent * 100).toFixed(0)
      const flatThresholds = videoThresholds.reduce((acc, curr) => {
        acc.push(curr.time)
        return acc
      }, [])
      flatThresholds.forEach((val, i) => {
        const valReached = percent >= val - 2 && percent < val + 2
        const isAlreadyReached = videoThresholds[i].reached
        if (valReached && !isAlreadyReached) {
          videoThresholds[i].reached = true
          typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push({
            event: VIDEO_PROGRESS,
            video_title: title,
            video_percent: videoThresholds[i].time
          })
        }
      })
    })
    player.on('ended', (e) => {
      typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push({
        event: VIDEO_PROGRESS,
        video_title: title,
        video_percent: 100
      })
      typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push({
        event: VIDEO_COMPLETE,
        video_title: title
      })
    })
  }, [])

  return (
    <Container>
      <PlayerContainer isLarge={ isLarge }>
        <PlayerVideo ref={ iframeRef } src={ `https://player.vimeo.com/video/${code}?embedparameter=value` } width='960' height='540' frameBorder='0' allowFullScreen />
      </PlayerContainer>
    </Container>
  )
}

ArticleBlockVideo.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  isLarge: PropTypes.bool
}

export default ArticleBlockVideo
